<template>
  <div class="goto" ref="goto" v-if="isMobile">
    <div v-if="visible">
      <slot></slot>
    </div>
  </div>
  <el-collapse-transition v-else>
    <div v-if="visible">
      <slot></slot>
    </div>
  </el-collapse-transition>
</template>

<script>
/**
 * Collapse transition on desktop or bring child into view on mobile
*/
export default {
  name: 'NextTransition',
  methods: {
    scrollIntoView() {
      this.$nextTick(() => {
        this.$refs.goto.scrollIntoView(true);
      });
    },
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters['dimensionStore/isMobile'];
    },
  },
  watch: {
    visible: {
      handler(value) {
        if (this.isMobile && value) this.scrollIntoView();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.goto{
  display: block;
}
</style>
